import React from "react";
import { Link } from "react-router-dom";



function ContentCard({ item, priority = false }) {
  const detailPath =
    item.type === "news"
      ? `/news/${item.slug}`
      : `/courses/${item.slug}`;

  const imageSrc = item.image || "/images/default-content.jpg";

  return (
    <article className="content-card glass-card">
      <div className="content-card-image">
        <img src={imageSrc} alt={item.title} loading={priority ? "eager" : "lazy"} decoding="async" />
        <span className="content-card-category">{item.category}</span>
      </div>

      <div className="content-card-body">
        <h3>{item.title}</h3>

        <p>{item.summary}</p>

        <div className="content-card-footer">
         {item.type === "news" && (
  <span>
    {item.publishAt
      ? new Date(item.publishAt).toLocaleString("fa-IR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "بدون زمان انتشار"}
  </span>
)}

          {item.type === "course" && (
            <span>
              {item.level || "بدون سطح"} | {item.duration || "بدون زمان"}
            </span>
          )}

          <Link to={detailPath} className="content-card-link">
            مشاهده جزئیات
          </Link>
        </div>
      </div>
    </article>
  );
  
}

export default ContentCard;